var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroProductMediaPauseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.375,
    height: 15,
    viewBox: "0 0 12.375 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(-424 -255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M5.188,0A2.188,2.188,0,0,0,3,2.188V12.813a2.188,2.188,0,1,0,4.375,0V2.188A2.187,2.187,0,0,0,5.188,0Zm.938,12.813a.938.938,0,0,1-1.875,0V2.188a.938.938,0,1,1,1.875,0Z",
    transform: "translate(421 255)",
    fill: "#396dc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M16.188,0A2.188,2.188,0,0,0,14,2.188V12.813a2.188,2.188,0,0,0,4.375,0V2.188A2.188,2.188,0,0,0,16.188,0Zm.938,12.813a.938.938,0,0,1-1.875,0V2.188a.937.937,0,0,1,1.875,0Z",
    transform: "translate(418 255)",
    fill: "#396dc1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroProductMediaPauseIcon);
export default __webpack_public_path__ + "static/media/Asset-KuroProductMediaPauseIcon.7aeb752e914b506f6d40d9a9fb94ab87.svg";
export { ForwardRef as ReactComponent };